export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const FETCH_BRANDINGS = 'FETCH_BRANDINGS';
